import { APIClient } from "helpers/api_helper";
import * as url from "../helpers/url_helper"

const api = new APIClient();

// Get
export const getWorkingHour = async () => api.get(url.GET_WORKING_HOUR, {})
export const getBreakingTime = async () => api.get(url.GET_WORKING_HOUR, {})
// Add
export const updateWorkingHour = async (payload: any) => api.create(url.ADD_WORKING_HOUR, payload)
